import { render, staticRenderFns } from "./ai-chat-app.vue?vue&type=template&id=07c2b3d2&scoped=true"
import script from "./ai-chat-app.vue?vue&type=script&lang=ts"
export * from "./ai-chat-app.vue?vue&type=script&lang=ts"
import style0 from "./ai-chat-app.vue?vue&type=style&index=0&id=07c2b3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c2b3d2",
  null
  
)

export default component.exports